import { apolloClient } from "@/plugins/vue-apollo.js";

const updateLandlordPlan = async _variables => {
  try {
    const responseFromApi = await apolloClient.mutate({
      mutation: require("@/plans/api/mutations/update_landlord_plan.graphql"),
      variables: {
        id: _variables.id,
        input: _variables.input
      },
    });

    return responseFromApi;
  } catch (error) {
    return error;
  }
};

export { updateLandlordPlan };
